module.exports = __webpack_public_path__ + "static/media/icons8-lock.a1dd379e.svg";